import React from "react";
import './index.css';
import Article from "./Article";
import data from "./data.json";

const ArticleGrid = () => {

  return (
    <div className="articlesContainer">
        {data.articles.map((article) => {
        return <Article {...article} />;
      })}
    </div>
  );
};

export default ArticleGrid;
